import axiosClient from "./axiosClient";

export const SALE_STATS_CHANGED_EVENT = "fes-sale-stats-changed";

function notifySaleStatsChanged() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(SALE_STATS_CHANGED_EVENT));
  }
}

export const getSales = async (params = {}, config = {}) => {
  const res = await axiosClient.get("/sales/", { params, ...config });
  return res.data;
};

export const getSaleStats = async () => {
  const res = await axiosClient.get("/sales/stats/");
  return res.data;
};

export const getSale = async (saleId) => {
  const res = await axiosClient.get(`/sales/${saleId}/`);
  return res.data;
};

export const startSale = async (data) => {
  const res = await axiosClient.post("/sales/start/", data);
  notifySaleStatsChanged();
  return res.data;
};

export const transitionSale = async (saleId, data) => {
  const res = await axiosClient.post(`/sales/${saleId}/transition/`, data);
  notifySaleStatsChanged();
  return res.data;
};
